import { camelizeKeys } from 'humps';
import { post, validateScheme } from '@namespace/helpers';
import { apiRoutes } from './apiRoutes';
import { editIbanResponseDataShema } from './schemas';
import { EditIbanBody, EditIbanResponse } from './types';

export const editIban = (body: EditIbanBody) =>
  post<EditIbanResponse>({
    url: apiRoutes.editIban(),
    body,
    mode: 'cors'
  }).then((data) => {
    validateScheme(editIbanResponseDataShema, data, {
      name: 'editIban'
    });
    return camelizeKeys<EditIbanResponse>(data);
  });
